module.exports = __webpack_public_path__ + "img/417969.aa5be793.png";